import { commonViewTexts } from '../common';

const targetName = commonViewTexts.project;

export const projectListViewTexts = {
  buttons: {
    create: `${targetName}登録`,
    edit: commonViewTexts.edit,
    delete: commonViewTexts.delete
  },
  searchBar: {
    name: `${targetName}名`,
    status: 'ステータス',
    author: commonViewTexts.author,
    approver: '承認者'
  },
  header: {
    name: 'プロジェクト名',
    status: 'ステータス',
    author: commonViewTexts.author,
    approver: '承認者',
    dateCreated: commonViewTexts.dateCreated,
    dateUpdated: commonViewTexts.dateUpdated
  }
} as const;
